import { render, staticRenderFns } from "./Comprobantes.vue?vue&type=template&id=7404cf4a&scoped=true"
import script from "./Comprobantes.vue?vue&type=script&lang=ts"
export * from "./Comprobantes.vue?vue&type=script&lang=ts"
import style0 from "./Comprobantes.vue?vue&type=style&index=0&id=7404cf4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7404cf4a",
  null
  
)

export default component.exports